import React from "react";
import Cropper from "react-easy-crop";

interface CropperWrapperProps {
  image: string | null;
  crop: { x: number; y: number };
  zoom: number;
  aspect: number;
  cropShape?: 'rect' | 'round';
  onCropChange: (crop: { x: number; y: number }) => void;
  onZoomChange: (zoom: number) => void;
  onCropComplete: (
    croppedArea: { x: number; y: number; width: number; height: number },
    croppedAreaPixels: { x: number; y: number; width: number; height: number }
  ) => void;
  containerWidth?: number | string;
  containerHeight?: number | string;
  style?: React.CSSProperties; // Optional prop for styles
}

export const CropperWrapper: React.FC<CropperWrapperProps> = ({
  image,
  crop,
  zoom,
  aspect,
  cropShape,
  onCropChange,
  onZoomChange,
  onCropComplete,
  style,
  containerWidth = "530px",
  containerHeight = "530px",
}) => {
  if (!image) return null;

  // Default styles
  const defaultStyle: React.CSSProperties = {
    position: "absolute",
    top: "86mm",
    left: "51.5%",
    transform: "translateX(-50%)",
    overflow: "hidden",
    width: containerWidth,
    height: containerHeight,
    zIndex: 10,
  };

  return (
    <div style={{ ...defaultStyle, ...style }}>
      <Cropper
        image={image}
        crop={crop}
        zoom={zoom}
        aspect={aspect}
        cropShape={cropShape}
        onCropChange={onCropChange}
        onZoomChange={onZoomChange}
        onCropComplete={onCropComplete}
        objectFit={"contain"}
        style={{
          containerStyle: {
            borderRadius: cropShape === "round" ? "50%" : "0",
          },
          cropAreaStyle: {
            width: `${containerWidth}!important`,
            height: `${containerHeight}!important`,
          }
        }}
      />
    </div>
  );
};
